import {
  ScorePill,
  FlagInline,
  SourceLink,
  ExternalLink,
  type MatchVariant,
} from "../_components/match-detail-showcase";

export const VARIANTS: MatchVariant[] = [
  {
    slug: "pep-person",
    label: "Person — PEP list",
    headerIcon: "person",
    name: "Javier Milei",
    source: "PEP",
    cards: [
      {
        icon: "fact_check",
        title: "Match details",
        items: [
          {
            kind: "row",
            icon: "readiness_score",
            label: "Confidence Score:",
            value: <ScorePill score={0.92} />,
          },
          {
            kind: "row",
            icon: "public",
            label: "Country of Residence:",
            value: <FlagInline country="Argentina" />,
          },
          { kind: "row", icon: "calendar_today", label: "DOB:", value: "1970-10-22" },
          { kind: "row", icon: "barcode", label: "ID:", value: "PEP-ARIT-Q52395487" },
          { kind: "row", icon: "category", label: "Entity Type:", value: "Individual" },
          { kind: "row", icon: "badge", label: "PEP class:", value: "Head of State" },
        ],
      },
      {
        icon: "badge",
        title: "Aliases",
        items: [
          {
            kind: "block",
            icon: "badge",
            label: "Alternative Names:",
            items: ["Javier Gerardo Milei"],
          },
          {
            kind: "block",
            icon: "work",
            label: "Positions:",
            items: [
              "Member of the Argentine Chamber of Deputies (2021–2023)",
              "President of La Libertad Avanza (since 2019)",
              "President of Argentina (since 2023)",
            ],
          },
          {
            kind: "row",
            icon: "language",
            label: "Watchlist:",
            value: <SourceLink source="PEP" />,
          },
        ],
      },
      {
        icon: "distance",
        title: "Locations and watchlist",
        items: [
          {
            kind: "row",
            icon: "distance",
            label: "Place of Birth:",
            value: "Buenos Aires, Argentina",
          },
          {
            kind: "block",
            icon: "groups",
            label: "Relations:",
            items: ["Sibling: Karina Milei"],
          },
          {
            kind: "row",
            icon: "link",
            label: "Web Source:",
            value: (
              <ExternalLink
                href="https://en.wikipedia.org/wiki/Javier_Milei"
                display="en.wikipedia.org"
              />
            ),
          },
          {
            kind: "row",
            icon: "language",
            label: "Watchlist:",
            value: <SourceLink source="PEP" />,
          },
        ],
      },
    ],
  },

  {
    slug: "adverse-media",
    label: "Adverse Media",
    headerIcon: "article",
    name: "Microsoft erreicht wichtigen Meilenstein auf dem Weg zur Klimaneutralität",
    source: "ADV-MEDIA",
    cards: [
      {
        icon: "fact_check",
        title: "Match details",
        items: [
          {
            kind: "row",
            icon: "readiness_score",
            label: "Confidence Score:",
            value: <ScorePill score={0.74} />,
          },
          {
            kind: "row",
            icon: "public",
            label: "Country:",
            value: <FlagInline country="Germany" />,
          },
          { kind: "row", icon: "calendar_today", label: "Published:", value: "2026-02-18" },
          { kind: "row", icon: "barcode", label: "ID:", value: "ADVMEDIA-MSNDEUTSCHLAND-2300849" },
          { kind: "row", icon: "category", label: "Entity Type:", value: "Organization" },
          { kind: "row", icon: "translate", label: "Language:", value: "DE" },
        ],
      },
      {
        icon: "description",
        title: "Mentions",
        items: [
          {
            kind: "block",
            icon: "description",
            label: "Summary:",
            items: [
              "Vor sechs Jahren hat sich Microsoft das Ziel gesetzt, bis zum Jahr 2030 klimaneutral zu werden.",
            ],
          },
          {
            kind: "block",
            icon: "person",
            label: "Individuals:",
            items: ["Hallvard Granheim", "Melanie Nakagawa"],
          },
          {
            kind: "block",
            icon: "domain",
            label: "Entities:",
            items: ["Microsoft", "Microsoft Datacenter Irland", "Statkraft", "Cloud Computing"],
          },
        ],
      },
      {
        icon: "distance",
        title: "Locations and source",
        items: [
          {
            kind: "row",
            icon: "link",
            label: "Media Source:",
            value: <ExternalLink href="https://www.msn.com" display="msn.com" />,
          },
          { kind: "row", icon: "tag", label: "Keywords:", value: "EnvironmentalCrime" },
          {
            kind: "row",
            icon: "image",
            label: "Image:",
            value: "img-s-msn-com.akamaized.net",
          },
          {
            kind: "row",
            icon: "language",
            label: "Data Source:",
            value: (
              <ExternalLink
                href="https://www.msn.com/de-de/finanzen/top-stories/microsoft-erreicht-wichtigen-meilenstein-auf-dem-weg-zur-klimaneutralitaet"
                display="ADV-MEDIA"
              />
            ),
          },
        ],
      },
    ],
    article: {
      url: "https://www.msn.com/de-de/finanzen/top-stories/microsoft-erreicht-wichtigen-meilenstein-auf-dem-weg-zur-klimaneutralitaet",
      domain: "msn.com",
      publishedAt: "2026-02-18",
      language: "DE",
      imageAlt: "Microsoft Datacenter Irland",
      keywords: ["EnvironmentalCrime", "Klimaneutralität", "Microsoft", "Statkraft"],
      body: [
        "Vor sechs Jahren hat sich Microsoft das Ziel gesetzt, bis zum Jahr 2030 klimaneutral zu werden. Der Konzern aus Redmond zählt damit zu den ersten globalen Technologieunternehmen, die sich auf einen Netto-Null-Pfad festgelegt haben — und jetzt liegt mit dem irischen Rechenzentrum ein erster konkreter Meilenstein vor.",
        "Hallvard Granheim, CEO des norwegischen Energieversorgers Statkraft, bestätigte den langfristigen Liefervertrag in einer gemeinsamen Mitteilung. Der Vertrag sichert dem Datacenter Irland Strom aus erneuerbaren Quellen über die kommenden zwölf Jahre — ein Volumen, das laut Branchenanalysten ausreicht, um den Energiebedarf von rund 300.000 Haushalten zu decken.",
        'Melanie Nakagawa, Chief Sustainability Officer bei Microsoft, betonte in einer Stellungnahme die strategische Bedeutung des Abschlusses: "Cloud-Infrastruktur ist ohne sauberen Strom nicht zukunftsfähig. Mit diesem Vertrag stellen wir sicher, dass unsere europäischen Kunden auf eine wirklich kohlenstoffarme Cloud zugreifen können."',
        "Kritiker bemängeln allerdings, dass Microsofts Gesamtbilanz weiterhin durch den steigenden Energieverbrauch von KI-Workloads belastet wird. Der Konzern hatte zuletzt eingeräumt, dass die eigenen Emissionen seit 2020 trotz Effizienzgewinnen um knapp 30 Prozent gestiegen sind — vor allem getrieben durch Investitionen in generative KI.",
        "Die Vereinbarung mit Statkraft gilt dennoch als wegweisendes Beispiel für die Branche. Mehrere weitere Hyperscaler sollen nach Informationen aus dem Markt an ähnlichen langfristigen Power Purchase Agreements arbeiten.",
      ],
    },
  },

  {
    slug: "organization",
    label: "Entity (organization)",
    headerIcon: "domain",
    name: "Wagner Group",
    source: "SDN",
    cards: [
      {
        icon: "fact_check",
        title: "Match details",
        items: [
          {
            kind: "row",
            icon: "readiness_score",
            label: "Confidence Score:",
            value: <ScorePill score={0.94} />,
          },
          {
            kind: "row",
            icon: "public",
            label: "Country:",
            value: <FlagInline country="Russia" />,
          },
          { kind: "row", icon: "calendar_today", label: "Founded:", value: "2014" },
          { kind: "row", icon: "barcode", label: "ID:", value: "EUCSLSDN-WAGNER-04122" },
          { kind: "row", icon: "category", label: "Entity Type:", value: "Organization" },
          { kind: "row", icon: "factory", label: "Sector:", value: "Paramilitary" },
        ],
      },
      {
        icon: "badge",
        title: "Aliases",
        items: [
          {
            kind: "block",
            icon: "badge",
            label: "Alternative Names:",
            items: ["Группа Вагнера", "PMC Wagner", "Private Military Company Wagner"],
          },
          {
            kind: "row",
            icon: "apartment",
            label: "Headquarters:",
            value: "Saint Petersburg, Russia",
          },
          {
            kind: "row",
            icon: "language",
            label: "Watchlist:",
            value: <SourceLink source="SDN" />,
          },
        ],
      },
      {
        icon: "distance",
        title: "Locations and watchlist",
        items: [
          {
            kind: "block",
            icon: "distance",
            label: "Operating regions:",
            items: ["Russia", "Syria", "Mali", "Central African Republic", "Libya"],
          },
          {
            kind: "row",
            icon: "link",
            label: "Web Source:",
            value: <ExternalLink href="https://ofac.treasury.gov" display="ofac.treasury.gov" />,
          },
          {
            kind: "row",
            icon: "language",
            label: "Watchlist:",
            value: <SourceLink source="SDN" />,
          },
        ],
      },
    ],
  },

  {
    slug: "vessel",
    label: "Vessel",
    headerIcon: "directions_boat",
    name: "M/V Stoykiy",
    source: "SDN",
    cards: [
      {
        icon: "fact_check",
        title: "Match details",
        items: [
          {
            kind: "row",
            icon: "readiness_score",
            label: "Confidence Score:",
            value: <ScorePill score={0.82} />,
          },
          {
            kind: "row",
            icon: "flag",
            label: "Flag State:",
            value: <FlagInline country="Russia" />,
          },
          { kind: "row", icon: "calendar_today", label: "Built:", value: "2008" },
          { kind: "row", icon: "barcode", label: "IMO:", value: "9876543" },
          { kind: "row", icon: "category", label: "Entity Type:", value: "Vessel" },
          { kind: "row", icon: "directions_boat", label: "Vessel type:", value: "Cargo" },
        ],
      },
      {
        icon: "badge",
        title: "Aliases",
        items: [
          {
            kind: "block",
            icon: "badge",
            label: "Alternative Names:",
            items: ["Стойкий"],
          },
          {
            kind: "block",
            icon: "tag",
            label: "Identifiers:",
            items: ["IMO 9876543", "MMSI 273287950", "Call Sign UFLA"],
          },
          {
            kind: "row",
            icon: "language",
            label: "Watchlist:",
            value: <SourceLink source="SDN" />,
          },
        ],
      },
      {
        icon: "distance",
        title: "Locations and watchlist",
        items: [
          {
            kind: "row",
            icon: "anchor",
            label: "Home port:",
            value: "Saint Petersburg, Russia",
          },
          {
            kind: "row",
            icon: "person",
            label: "Operator:",
            value: "Sovcomflot PJSC",
          },
          {
            kind: "row",
            icon: "language",
            label: "Watchlist:",
            value: <SourceLink source="SDN" />,
          },
        ],
      },
    ],
  },

  {
    slug: "aircraft",
    label: "Aircraft",
    headerIcon: "flight",
    name: "RA-02791",
    source: "SDN",
    cards: [
      {
        icon: "fact_check",
        title: "Match details",
        items: [
          {
            kind: "row",
            icon: "readiness_score",
            label: "Confidence Score:",
            value: <ScorePill score={0.86} />,
          },
          {
            kind: "row",
            icon: "flag",
            label: "Nationality of registration:",
            value: <FlagInline country="Russia" />,
          },
          {
            kind: "row",
            icon: "calendar_today",
            label: "Manufacture date:",
            value: "2000-12-01",
          },
          {
            kind: "row",
            icon: "barcode",
            label: "ID:",
            value: "EUCSLSDN-CYBER2ELECTIONUKRAINE-27197",
          },
          { kind: "row", icon: "category", label: "Entity Type:", value: "Aircraft" },
          {
            kind: "row",
            icon: "flight",
            label: "Aircraft model:",
            value: "Hawker 800XP",
          },
        ],
      },
      {
        icon: "badge",
        title: "Aliases",
        items: [
          {
            kind: "block",
            icon: "badge",
            label: "Alternative Names:",
            items: ["M-VITO"],
          },
          {
            kind: "block",
            icon: "tag",
            label: "Identifiers:",
            items: [
              "Mode S Transponder Code: 140AE7",
              "Aircraft Serial: 258512",
              "Aircraft Operator: Beratex Group Limited",
            ],
          },
          {
            kind: "row",
            icon: "language",
            label: "Watchlist:",
            value: <SourceLink source="SDN" />,
          },
        ],
      },
      {
        icon: "distance",
        title: "Locations and watchlist",
        items: [
          {
            kind: "row",
            icon: "person",
            label: "Operator:",
            value: "Beratex Group Limited",
          },
          {
            kind: "row",
            icon: "link",
            label: "Linked to:",
            value: "BERATEX GROUP LIMITED",
          },
          {
            kind: "row",
            icon: "shield",
            label: "Secondary sanctions risk:",
            value: "Ukraine-/Russia-Related Sanctions Regulations, 31 CFR 589.201 / 589.209",
          },
          {
            kind: "row",
            icon: "language",
            label: "Watchlist:",
            value: <SourceLink source="SDN" />,
          },
        ],
      },
    ],
  },

  {
    slug: "country",
    label: "Country",
    headerIcon: "public",
    name: "Democratic People's Republic of Korea",
    source: "UN-SC",
    cards: [
      {
        icon: "fact_check",
        title: "Match details",
        items: [
          {
            kind: "row",
            icon: "readiness_score",
            label: "Confidence Score:",
            value: <ScorePill score={0.99} />,
          },
          {
            kind: "row",
            icon: "public",
            label: "Country:",
            value: <FlagInline country="North Korea" />,
          },
          { kind: "row", icon: "calendar_today", label: "First listed:", value: "2006-10-14" },
          { kind: "row", icon: "barcode", label: "ID:", value: "UN-DPRK-001" },
          { kind: "row", icon: "category", label: "Entity Type:", value: "Country" },
          { kind: "row", icon: "map", label: "Region:", value: "Eastern Asia" },
        ],
      },
      {
        icon: "badge",
        title: "Aliases",
        items: [
          {
            kind: "block",
            icon: "badge",
            label: "Alternative Names:",
            items: ["North Korea", "DPRK", "조선민주주의인민공화국"],
          },
          { kind: "row", icon: "translate", label: "Languages:", value: "Korean" },
          {
            kind: "row",
            icon: "language",
            label: "Watchlist:",
            value: <SourceLink source="UN-SC" />,
          },
        ],
      },
      {
        icon: "distance",
        title: "Locations and watchlist",
        items: [
          { kind: "row", icon: "apartment", label: "Capital:", value: "Pyongyang" },
          { kind: "row", icon: "groups", label: "Population:", value: "25.7M (2023)" },
          {
            kind: "block",
            icon: "shield",
            label: "Sanctions programmes:",
            items: ["UN-DPRK", "OFAC NK-EO13687", "EU-DPRK"],
          },
          {
            kind: "row",
            icon: "language",
            label: "Watchlist:",
            value: <SourceLink source="UN-SC" />,
          },
        ],
      },
    ],
  },
];

export function getVariant(slug: string): MatchVariant | undefined {
  return VARIANTS.find((v) => v.slug === slug);
}
